import React from 'react';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Link from 'components/Link';
import Image from 'components/Image';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import s from './Ctawithimage.scss';

class Ctawithimage extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { gaAction, gaLabelPerfix } = this.props;
    const data = this.state.data || this.props.data;

    if (!(data && data.path && data.ctaimage)) {
      return null;
    }

    const scrollGAAttr = {
      ...(data.onScrollGA && data.id && { 'data-scrollga': data.id }),
    };

    return (
      <>
        {data.border && data.border === 'top' && <InterSectionBorder />}
        <div
          className={`${s.calWrapper} ${data.className}`}
          {...scrollGAAttr}
          id={
            data && data?.jumplinkId && data?.jumplinkId !== ''
              ? data?.jumplinkId
              : ''
          }
        >
          <Link
            to={data.path}
            doNotChangeDomain={data?.doNotChangeDomain}
            doNotChangeURL={data?.doNotChangeURL}
            data-newga={
              data.gaData || `${gaAction}#${gaLabelPerfix}/${data.path}`
            }
            target={data.target === '_blank' ? data.target : ''}
            forceTargetBlank={data.target === '_blank' ? data.target : ''}
            onClick={() => {
              if (data && data.id === 'cybersafe_hdfc_banner') {
                analyticsWrapper('ga4', {
                  event: 'user_click',
                  type: 'HDFC_Business_Slug',
                  label: data.path,
                });
              } else if (data && data.id === 'etmoneybusiness') {
                analyticsWrapper('ga4', {
                  event: 'user_click',
                  type: 'et_money_banner',
                  category: 'business_listing',
                });
              } else if (data && data.id === 'etmoney') {
                analyticsWrapper('ga4', {
                  event: 'user_click',
                  type: 'et_money_banner',
                  category: 'as_rhs',
                });
              } else {
                analyticsWrapper('ga4', {
                  event: 'user_click',
                  type: data?.id || 'cta_with_image',
                  category: data?.secname || data?.name || 'listing',
                });
              }
            }}
          >
            <div className={s.calBorder}>
              {data.top_heading && data.top_heading === 'yes' ? (
                <h6>{data.name}</h6>
              ) : (
                ''
              )}
              <Image
                msid={data.ctaimage ? data.ctaimage : 87357589}
                resizemode={4}
                width={data?.size ? data?.size : ''}
                alt={data.name}
                title={data.name || ''}
                placeHolderSrc="https://static.toiimg.com/photo/83033472.cms"
              />
              {data.btm_heading && data.btm_heading === 'yes' ? (
                <h5>
                  {data.id === 'taxcalculatorcta' ? (
                    <>
                      <span>Tax</span>Calculator
                    </>
                  ) : (
                    data.name
                  )}
                </h5>
              ) : (
                ''
              )}
            </div>
          </Link>
        </div>
        {data.border && data.border === 'bottom' && <InterSectionBorder />}
      </>
    );
  }
}

Ctawithimage.propTypes = {
  data: PropTypes.shape({}),
  gaAction: PropTypes.string,
  gaLabelPerfix: PropTypes.string,
  className: PropTypes.string,
  isWapView: PropTypes.bool,
};

Ctawithimage.defaultProps = {
  data: {},
  gaAction: '',
  gaLabelPerfix: '',
  className: '',
  isWapView: false,
};

export default Ctawithimage;
